module.exports = __webpack_public_path__ + "static/fv-board-68d2866805204feb5ce7144c049db2a3.jpg";